module.exports = __webpack_public_path__ + "static/media/offerpad_representative.f527997d.svg";